// src/components/MainView.jsx
import React from "react";
import HealthDashboard from "./HealthDashboard";
import Sidebar from "../layout/Sidebar";
import AdminUsers from "../views/AdminUsers";

export default function MainView({ user, isAdmin, view, setView, flagSnap = {} }) {
  const { adminHealth } = flagSnap;

  // Gate for admin features: admin OR storeadmin role
  const roles = Array.isArray(user?.roles) ? user.roles : [];
  const isStoreAdmin = roles.includes("storeadmin");

  // ALSO require the FM flag ui.adminUsers
  const canAdminUsers = (isAdmin || isStoreAdmin) && !!flagSnap.adminUsers;

  return (
    <main className="main">
      <div className="main-grid">
        {/* Left sidebar only for admins/storeadmins AND when FM flag is on */}
        {canAdminUsers && (
          <Sidebar onNavigate={setView} current={view} />
        )}

        <section className="content">
          {/* Home */}
          {view === "home" && (
            <div className="section">
              <h3 className="h3">Welcome</h3>
              <p>You’re logged in. Use the menu or the sidebar to navigate.</p>
            </div>
          )}

          {/* Admin → Service health (existing) */}
          {view === "admin-health" && isAdmin && adminHealth && (
            <div className="section">
              <h3 className="h3">Admin → Service health</h3>
              <HealthDashboard />
              <div className="spacer-12" />
              <button type="button" className="btn" onClick={() => setView("home")}>
                Back to Home
              </button>
            </div>
          )}

          {/* Admin → User Admin → List users (new) */}
          {view === "admin-users" && canAdminUsers && (
            <div className="section">
              <h3 className="h3">Admin → User Admin</h3>
              <AdminUsers />
            </div>
          )}
        </section>
      </div>
    </main>
  );
}